module.exports = __webpack_public_path__ + "img/Enmascarar grupo 24@2x.31c4ff2b.png";